const sideMenuActionTypes = {
  MENU_OPEN: 'MENU_OPEN',
  MENU_CLOSE: 'MENU_CLOSE',
  MENU_TOGGLE: 'MENU_TOGGLE',
  SET_SIDEBAR_COUNTERS: 'SET_SIDEBAR_COUNTERS',
  UPDATE_SIDEBAR_COUNTERS: 'UPDATE_SIDEBAR_COUNTERS',
};

export default sideMenuActionTypes;
